export default ['ru', 'en', 'cs'];

export function getLanguageTitle(lng) {
    switch (lng) {
        case 'ru': return 'Русский';
        case 'en': return 'English';
        case 'cs': return 'čeština';
        default: return '-';
    }
}